export default "__VITE_ASSET__DDpk77h0__"